window.ReservationWidget = function ($wrapper, widgetJsUri) {
  var $wrapper = $wrapper;
  var $form = $wrapper.find('#reservation-settings-form');
  var $examplePreview = $wrapper.find('#reservation_example_background');
  var $codePreview = $wrapper.find('#reservation-prettyprint');
  var $useModal = $form.find('#reservation_use_modal');
  var $locationWrapper = $form.find('#location');
  var $locationButton = $form.find('#reservation_button_location');
  var $openModalByDefaultLabel = $form.find("#open_modal_by_default_label");

  initReservation = function () {
    onChangedReservationParameters(this);
    $form.change(function () {
      console.log('reservation on change');
      onChangedReservationParameters(this);
    });

    $useModal.change(function () {
      if ($useModal.val() === '1') {
        $locationWrapper.show();
        $openModalByDefaultLabel.show();
        $locationButton.attr("disabled", false);
      } else {
        $locationWrapper.hide();
        $openModalByDefaultLabel.hide();
        $locationButton.attr("disabled", true);
      }
    });
  };

  onChangedReservationParameters = function (self) {
    console.log('reservation modal parameter changed');
    var data = $form.serializeArray();
    console.log(data);
    var widgetCode = generateReservationCode(data);

    $examplePreview.html(widgetCode[0]);
    $codePreview.text(widgetCode[1]);
    prettyPrint();
  };

  generateReservationCode = function (data) {
    console.log('generate reservation code');
    var $tbkrElement = $('<tbkr-bm-widget>');

    $.each(data, function(key, value) {
      if (value.value.trim()) {
        $tbkrElement.attr(value.name, value.value);
      }
    });

    return [$('<div>').append(
      $tbkrElement
    ).html(),
      $('<div>').append(
          $tbkrElement
      ).append(
          '\n'
      )
      .append(
              $('<script>').attr('src', widgetJsUri)
      ).html()
    ];
  };

  initReservation();
};

window.ShopWidget = function() {
  var $wrapper = $('.shop_module');
  var $form = $wrapper.find('#shop-settings-form');
  var $modulePreview = $wrapper.find('#shop-module-preview');
  var $codePreview = $wrapper.find('#shop-prettyprint');

  init = function () {
    $form.change(function () {
      console.log('shop form changed');
      renderCodeAndPreview();
    });
    renderCodeAndPreview();
  };

  renderCodeAndPreview = function() {
    var data = $form.serializeArray();
    console.log(data);
    var mode = 'embed';
    var link = shopBaseUrl + '/?';
    var $tbkrElement = $('<tbkr-shop-widget>');
    var codeContent;
    var previewContent;
    var collections = [];
    $.each(data, function(key, value) {
      if (value.value.trim()) {
        if (value.name === 'mode') {
          mode = value.value;
          $tbkrElement.attr(value.name, value.value);
        } else if (value.name.indexOf('collection_') !== -1) {
          collections.push(value.value);
        } else {
          if (value.name === 'primary-color') {
            value.value = value.value.replace('#', '');
          }
          $tbkrElement.attr(value.name, value.value);
          link += value.name + '=' + value.value + '&';
        }
      }
    });
    //link = link.slice(0, -1); //remove last &
    //Add active collections
    $tbkrElement.attr('collections', collections.join(','));
    link += 'collections=' + collections.join(',');

    if (mode === 'standalone') {
      //Render a link
      codeContent = link;
      previewContent = `<a href="${link}" target="_blank" class="btn btn-primary btn-large">Shop</a>`;
    } else {
      // Render the widget
      codeContent = previewContent = $('<div>').append(
              $tbkrElement
          ).append(
              '\n'
          )
          .append(
              $('<script>').attr('src', shopBaseUrl + '/tbkr-widget-import.min.js')
          ).html();

    }
    $modulePreview.html(previewContent);
    $codePreview.text(codeContent);
    prettyPrint();
  };

  init();
};


// WEBPACK FOOTER //
// ./pages/forwebmasters/reservationWidget.js